import { navigateTo } from '../../../../../../common/frontend/route-utils.js'
import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import { formatDisplayDate } from '../../../../../../common/utils/format-utils.js'
import type { NextEventPayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import { SquareArrowRight } from '../../../../../components/icon/solar-icons.js'
import './next-event-card.css'

/** "27.06.2026" or, for a multi-day event, "27.06 – 28.06.2026". */
const formatEventRange = (startIso: string, endIso: string | null, lang: Language): string => {
    const start = startIso.split('T')[0]
    const end = endIso?.split('T')[0] ?? null
    if (!end || end === start) return formatDisplayDate(start, 'short', lang)
    return `${formatDisplayDate(start, 'short', lang)} – ${formatDisplayDate(end, 'short', lang)}`
}

export const NextEventCard = ({ data, lang }: { data: NextEventPayload; lang: Language }) => {
    const c = t.portal.dashboard.cards.next_event

    if (!data.event) {
        return <span className="portal-card__empty">{c.empty(lang)}</span>
    }

    const ev = data.event
    const meta = [ev.place, ev.category].filter(Boolean).join(' · ')

    // Open the event's detail (its Notion page); fall back to the Üritused tab.
    const openDetail = () => {
        if (ev.notionUrl) window.open(ev.notionUrl, '_blank', 'noreferrer')
        else navigateTo('/events')
    }

    return (
        <div
            className="portal-next-event"
            role="button"
            tabIndex={0}
            onClick={openDetail}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') openDetail()
            }}
        >
            <div className="portal-next-event__poster-wrap">
                {ev.posterUrl ? (
                    <img className="portal-next-event__poster" src={ev.posterUrl} alt={ev.name} />
                ) : (
                    <div className="portal-next-event__poster portal-next-event__poster--placeholder">
                        📅
                    </div>
                )}
                <span className="portal-next-event__open" aria-hidden="true">
                    <SquareArrowRight size={16} weight="Linear" />
                </span>
            </div>
            <div className="portal-next-event__info">
                <span className="portal-next-event__date">
                    {formatEventRange(ev.startsAt, ev.endsAt, lang)}
                </span>
                <span className="portal-next-event__name">{ev.name}</span>
                {meta && <span className="portal-next-event__place">{meta}</span>}
            </div>
        </div>
    )
}
